import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import RtReconciliationSearchUnmatchedResponse from "../RtReconciliationSearchUnmatchedResponse";
import ModelProxyClass from "./ModelProxyClass";
import ReconciliationLineItem from "../ReconciliationLineItem";


/**
 * @class RtReconciliationSearchUnmatchedResponseBase
 * @extends ModelBaseClass
 * @property {[ReconciliationLineItem]} unmatchedCollectionLineItems
 * @property {[ReconciliationLineItem]} unmatchedRtLineItems
 */
class RtReconciliationSearchUnmatchedResponseBase extends ModelBaseClass {
	/**
	 * @type {[ReconciliationLineItem]} unmatchedCollectionLineItems
	 */
	unmatchedCollectionLineItems;
	/**
	 * @type {[ReconciliationLineItem]} unmatchedRtLineItems
	 */
	unmatchedRtLineItems;

	/**
	 * Instantiates a new instance of RtReconciliationSearchUnmatchedResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {RtReconciliationSearchUnmatchedResponse}
	 */
	static create(genericObject) {
		const newRtReconciliationSearchUnmatchedResponse = new RtReconciliationSearchUnmatchedResponse();
		newRtReconciliationSearchUnmatchedResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newRtReconciliationSearchUnmatchedResponse;
	}

	/**
	 * Instantiates a new array of RtReconciliationSearchUnmatchedResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[RtReconciliationSearchUnmatchedResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newRtReconciliationSearchUnmatchedResponseArray = [];
		genericArray.forEach(genericObject => {
			newRtReconciliationSearchUnmatchedResponseArray.push(RtReconciliationSearchUnmatchedResponse.create(genericObject));
		});
		return newRtReconciliationSearchUnmatchedResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('unmatchedCollectionLineItems', '[ReconciliationLineItem]'),
	ModelBaseClass.createModelProperty('unmatchedRtLineItems', '[ReconciliationLineItem]'),
];

export default RtReconciliationSearchUnmatchedResponseBase;
